module.exports = __webpack_public_path__ + "media/product/week-1-dffa68f8.png";